<template>
    <div v-show="schedulingNewPatients">
      <hp5-spacing-vertical sm="sm"></hp5-spacing-vertical>
      <hp5-semantic size-selection="xs">
        <span class="schedulingPatients"><hp5-icon name="system-success-base" size="xs" /> Scheduling new patients</span>
      </hp5-semantic>
    </div>
</template>
<script setup>

    const props = defineProps({
        result: Object
    })

    const schedulingNewPatients = computed(() => props.result.acceptingNewPatients)

</script>

<style lang="scss" scoped>
  .schedulingPatients {
    display: flex;
    align-items: center;
  }
  
  hp5-icon {
    margin-right: var(--spacing-xxs);
  }
</style>